<template>
  <v-container>
  <v-card elevation="6" class="" color="#F5F5F5">
    <v-card-title class="" style="color:#AF8936">
      <div>
        <h2 class="hidden-sm-and-down">{{formTitle}}</h2>
        <h4 v-if="currentUser.sala" style="color:#225883">
          {{ currentUser.sala.nombre }}
        </h4>
      </div>
      <div class="flex-grow-1"></div>
      <v-btn v-if="roleUser=='superadmin' || roleUser=='abogado'" small style="background-color:#0A4A79" class="mr-1" to="/promociones/firma" dark>
        <v-icon small dark class="mr-1">mdi-plus</v-icon> Presentar Escrito
        <div class="flex-grow-1"></div>
      </v-btn>
      <v-btn v-if="roleUser=='superadmin'" small style="background-color:#0A4A79" class="mr-1" to="/escritos/panel" dark>
        <v-icon small dark class="mr-1">mdi-file</v-icon> Sentencias y Amparos
        <div class="flex-grow-1"></div>
      </v-btn>
      <v-btn v-if="roleUser=='superadmin'" small style="background-color:#0A4A79" class="mr-1" to="/panel" dark>
        <v-icon small dark class="mr-3">mdi-file</v-icon> {{btnTitle}}
        <div class="flex-grow-1"></div>
      </v-btn>

    </v-card-title>

    <v-form class="mx-5" ref="search" v-model="validateToca" lazy-validation>
      <v-card flat>
        <v-divider></v-divider>
        <h4 style="color:#0A4A79" class="mt-3 ml-3">Filtros</h4>
        <v-card-text>
          <v-row class="mb-1">
            <v-col v-if="sala_id <= 11" cols="12" :md="(roleUser != 'magistrado' || roleUser != 'secacuerdos') && !currentUser.sala_id ? 3 : 6">
              <v-text-field
                v-model="no_toca"
                label="Toca"
                prepend-icon="mdi-folder-outline"
                clearable
                outlined
                dense
                @blur="clear()"
                :rules="tocaRules"
                >
              </v-text-field>
            </v-col>
            <v-col v-if="sala_id == 12" cols="12" :md="!currentUser.sala_id ? 3 : 6">
              <v-text-field
                v-model="no_expediente"
                label="Asunto"
                prepend-icon="mdi-folder-outline"
                clearable
                outlined
                dense
                :rules="tocaRules"
                @blur="clear()"
                >
              </v-text-field>
            </v-col>
            <v-col cols="12" :md="roleUser != 'magistrado' && !currentUser.sala_id ? 3 : 6">
              <v-select
                :items="listStatus"
                v-model="status"
                label="Estatus"
                prepend-icon="mdi-file-alert-outline"
                item-value="id"
                item-text="nombre"
                clearable
                outlined
                dense
                >
              </v-select>
            </v-col>
            <v-col v-if="validUser && !currentUser.sala_id && (roleUser != 'magistrado' || roleUser != 'secacuerdos')" cols="12" md="6">
              <v-select
                v-model="sala_id"
                :items="listSalas"
                label="Área"
                prepend-icon="mdi-map-marker"
                item-value="id"
                item-text="nombre"
                outlined
                clearable
                :disabled="!validUser"
                dense
              >
              </v-select>
            </v-col>
          </v-row>
          <!-- <v-divider vertical></v-divider> -->
          <v-row v-if="sala_id != 13" class="mt-n9">
          <v-spacer></v-spacer>
            <v-col cols="12" md="2">
              <v-btn class="mb-3 white--text" small block color="#0A4A79" :disabled="!validateToca" @click="clickSearch()" >
                <v-icon class="mr-4">mdi-magnify</v-icon>
                Buscar
              </v-btn>
            </v-col>
          </v-row>

          <v-row class="mt-n3">
            <v-spacer></v-spacer>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card flat class="mt-2">
        <div v-if="roleUser == 'abogado'">
          <v-card>
            <v-row > <v-col align="center"><b style="color:#225883">CONTESTACIONES PENDIENTES</b></v-col></v-row>
            <v-tabs
              v-model="active_tab"
              background-color="white"
              color="indigo"
              centered
              icons-and-text
              show-arrows
            >
              <v-tabs-slider ></v-tabs-slider>
              <v-tab href="#tab-1" @click="sala_id=''">
                Promociones de salas
                <v-badge v-if="pendientesLeer.promociones > 0" light :content="pendientesLeer.promociones" color="red" overlap>
                   <v-icon>mdi-email</v-icon>
                </v-badge>
                <v-icon v-else light>mdi-email</v-icon>
              </v-tab>

              <v-tab href="#tab-2" @click="sala_id=12">
                Asuntos Laborales
                <v-badge v-if="pendientesLeer.expedientes_laboral > 0" light :content="pendientesLeer.expedientes_laboral" color="red" overlap>
                   <v-icon light>mdi-folder</v-icon>
                </v-badge>
                <v-icon v-else light>mdi-folder</v-icon>
              </v-tab>

              <v-tab href="#tab-3" @click="sala_id=13">
                  Buzón Presidencia
                <v-badge v-if="pendientesLeer.buzon > 0" light :content="pendientesLeer.buzon" color="red" overlap>
                   <v-icon light >mdi-mailbox-up</v-icon>
                </v-badge>
                <v-icon v-else light>mdi-mailbox-up</v-icon>
              </v-tab>
            </v-tabs>
          </v-card>
        </div>

        <!-- <div v-if="roleUser == 'secacuerdos' && turnados == true">
          <v-alert
            icon="mdi-alert"
            color="#E65100"
            border="left"
            dense
            outlined
            dismissible
          >
            Tiene escritos pendientes por leer
          </v-alert>
        </div> -->
        <div v-if="showAlert">
          <v-alert
            prominent
            outlined
            type="error"
           >
            <v-row align="center">
              <v-col class="grow hidden-xs-only">No se encontraron registros relacionados con la busqueda.</v-col>
              <v-col class="grow hidden-sm-and-up">No hay registros.</v-col>
            </v-row>
          </v-alert>
        </div>
          <template>
            <v-card-title  style="color:#0A4A79">
              <h5>{{ titleTabla }}</h5>
              <div class="flex-grow-1"></div>
            </v-card-title>

                <v-data-table
                  dense
                  align="left"
                  :loading="loadingTable"
                  :headers="headers"
                  :items="listData"
                  item-key="id"
                  :page.sync="page"
                  :items-per-page="per_page_table"
                  hide-default-footer
                  no-data-text="No se Encontraron Registros"
                  @page-count="pageCount = $event"
                >
                <template v-slot:item.status_secacuerdos="{ item }">
                  <div class="">
                    <v-tooltip v-if="item.status == 2  && roleUser == 'secretariageneral'" left>

                      <template v-slot:activator="{ on }">
                        <v-icon
                          left
                          color="#E65100"
                          v-on="on"
                          >
                        mdi-sim-alert</v-icon>
                      </template>
                      <span>Pendiente</span>
                    </v-tooltip>

                    <v-tooltip v-if="item.status == 3 && roleUser == 'secretariageneral'" left>

                      <template v-slot:activator="{ on }">
                        <v-icon
                          left
                          color="green"
                          v-on="on"
                          >
                        mdi-check-circle-outline</v-icon>
                      </template>
                      <span>Contestada</span>
                    </v-tooltip>
                    {{ item.numero_completo}}
                  </div>
                </template>

                <template v-slot:item.numero_completo="{ item }">
                <v-tooltip v-if="item.status == 2 && roleUser == 'abogado'" left>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      left
                      color="grey"
                      v-on="on"
                      >
                    mdi-file-clock-outline</v-icon>
                  </template>
                  <span>Pendientes de contestación</span>
                </v-tooltip>
                <v-tooltip v-if="(item.status == 3 && item.contestacion_leida == 0) && (roleUser == 'abogado')" left>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      left
                      color="#E65100"
                      v-on="on"
                      >
                    mdi-email-alert</v-icon>
                  </template>
                  <span>Pendientes por leer</span>
                </v-tooltip>
                <v-tooltip v-if="(item.status == 3 && item.contestacion_leida == 1 ) && (roleUser == 'abogado')"  left>
                  <!-- <v-tooltip left> -->
                  <template v-slot:activator="{ on }">
                    <v-icon
                      left
                      color="green"
                      v-on="on"
                      >
                    mdi-check-circle-outline</v-icon>
                  </template>
                  <span>Contestada</span>
                </v-tooltip>
                {{ item.numero_completo}}
              </template>

              <template v-slot:item.area="{ item }">
                <td><span>Sala {{item.sala_id}}</span></td>
              </template>

                <template v-slot:item.abogado="{ item }">
                  <span v-if="item.abogado">Abogado: {{item.abogado}}</span><br>
                </template>

                <template v-slot:item.status="{ item }">
                  <td v-if="item.status == 2 && item.firma_magistrado == 0" >
                    <v-icon color="red">
                      mdi-file-remove
                    </v-icon>Pendiente de firma
                  </td>
                  <td v-else-if="item.status == 2 && item.firma_magistrado == 1" >
                    <v-icon color="green">
                      mdi-file-check
                    </v-icon>Firmado
                  </td>
                  <td v-else-if="item.status == 2" >Registrada</td>
                  <td v-if="item.status == 3" >Contestada</td>
                </template>

                <template v-slot:item.fechas="{ item }" >
                  <td>
                    <span v-if="item.fecha_contestacion">Contestación: {{item.fecha_contestacion | formatDate}}</span><br v-if="item.fecha_contestacion">
                    <span>Registrada: {{item.created_at | formatDate}} {{ }}</span>
                  </td>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-row>
                  <v-btn v-if="(sala_id <= 11 || sala_id == '') && (roleUser != 'magistrado' || roleUser != 'secacuerdos')" class=""  dark x-small color="green" @click="showPromocion(item)">
                    <v-icon small dark left>mdi-file</v-icon>
                    Ver promoción
                  </v-btn>
                  <v-btn v-if="(sala_id <= 11 || sala_id == '') && (roleUser != 'magistrado' || roleUser != 'secacuerdos')" class="ml-1"  dark x-small color="indigo" @click="showToca(item)">
                    <v-icon small dark left>mdi-folder</v-icon>
                    Ver Historial
                  </v-btn>
                  <!-- <v-btn v-if="(sala_id <= 11 || sala_id == '') && roleUser == 'magistrado' && item.firma_magistrado == 1" class="ml-1"  dark x-small color="primary" @click="firmar(item)">
                    <v-icon small dark left>mdi-pen</v-icon>
                    Ver Acuerdo
                  </v-btn>
                  <v-btn v-else-if="(sala_id <= 11 || sala_id == '') && roleUser == 'magistrado'" class="ml-1"  dark x-small color="primary" @click="firmar(item)">
                    <v-icon small dark left>mdi-pen</v-icon>
                    Firmar Acuerdo
                  </v-btn> -->
                  </v-row>
                  <v-row>
                  <v-btn v-if="sala_id == 12" class=""  dark x-small color="green" @click="showExpediente(item)">
                    <v-icon small dark left>mdi-file</v-icon>
                    Ver asunto
                  </v-btn>
                  <v-btn v-if="(sala_id == 12) && (roleUser != 'magistrado' || roleUser != 'secacuerdos')" class="ml-1"  dark x-small color="indigo" @click="showHistorialExp(item)">
                    <v-icon small dark left>mdi-folder</v-icon>
                    Ver Historial
                  </v-btn>
                </v-row>
                <v-row>
                  <v-btn v-if="sala_id == 13" class=""  dark x-small color="green" @click="showBuzon(item)">
                    <v-icon small dark left>mdi-file</v-icon>
                    Ver escrito
                  </v-btn>
                </v-row>
                </template>

                  <template v-if="sala_id == 13" v-slot:item.asunto="{ item }">
                    <v-tooltip v-if="(item.fecha_contestacion == null) && roleUser == 'presidencia'" left>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          left
                          color="#E65100"
                          v-on="on"
                          >
                        mdi-sim-alert</v-icon>
                      </template>
                      <span>Pendientes</span>
                    </v-tooltip>
                    <v-tooltip v-if="item.fecha_contestacion && roleUser == 'presidencia'" left>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          left
                          color="green"
                          v-on="on"
                          >
                        mdi-check-circle-outline</v-icon>
                      </template>
                      <span>Contestada</span>
                    </v-tooltip>

                    <v-tooltip v-if="(item.buzones_pendientes_leer == 0 && item.fecha_contestacion != null)  && roleUser == 'abogado'" left>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          left
                          color="#E65100"
                          v-on="on"
                          >
                        mdi-email-alert</v-icon>
                      </template>
                      <span>Pendientes por leer</span>
                    </v-tooltip>
                    <v-tooltip v-if="item.fecha_contestacion && item.buzones_pendientes_leer > 0 && roleUser == 'abogado'" left>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          left
                          color="green"
                          v-on="on"
                          >
                        mdi-check-circle-outline</v-icon>
                      </template>
                      <span>Contestada</span>
                    </v-tooltip>
                      <v-tooltip v-if="item.fecha_contestacion == null && roleUser == 'abogado'" left>
                        <!-- <v-tooltip left> -->
                        <template v-slot:activator="{ on }">
                          <v-icon
                            left
                            color="grey"
                            v-on="on"
                            >
                          mdi-file-clock-outline</v-icon>
                        </template>
                        <span>Pendiente de Contestación</span>
                      </v-tooltip>
                      {{ item.asunto}}
                    <!-- </div> -->
                  </template>
                  <template v-if="sala_id == 13" v-slot:item.abogado="{ item }">
                    <span v-if="item.abogado">Abogado: {{item.abogado}}</span><br>
                  </template>


                </v-data-table>
                <div class="text-center pt-2">
                  <v-pagination
                    v-if="pagination.total > 1"
                    v-model="pagination.current"
                    :length="pagination.total"
                    :total-visible="7"
                    @input="onPageChange"
                    color="blue"
                    circle
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                  ></v-pagination>
                </div>
          </template>
      </v-card>
    </v-form>

    <v-row justify="space-around">
      <v-col cols="auto">
       <v-dialog
         v-model="dialog"
         persistent
         max-width="70%"
       >
         <template>
           <v-card>
             <v-form @submit.prevent="saveJuez" ref="form" v-model="valid" lazy-validation>
             <v-toolbar
               color="grey darken-2"
               dense
               dark
             >{{historialTitle}}
             <v-spacer></v-spacer>
               <v-btn
                 dark
                 text
                 @click="close()"
               >
                 Cerrar
                 <v-icon>mdi-close</v-icon>
               </v-btn>
           </v-toolbar>

            <v-data-table
              align="left"
              :loading="loadingTable"
              :headers="headersHistorial"
              :items="listHistorial"
              item-key="id"
              :page.sync="page"
              :items-per-page="per_page_table_historial"
              hide-default-footer
              no-data-text="No se Encontraron Registros"
              @page-count="pageCount = $event"
            >
            <v-toolbar
              color="grey darken-2"
              dense
              dark
            >Registro del Toca {{numero_completo}}
            <v-spacer></v-spacer>
              <v-btn
                dark
                text
                @click="close()"
              >
                Cerrar
                <v-icon>mdi-close</v-icon>
              </v-btn>
          </v-toolbar>
            <template v-slot:item.status="{ item }">
              <td v-if="item.status == 2" >Registrada</td>
              <td v-if="item.status == 3" >Contestada</td>
            </template>

            <template v-slot:item.area="{ item }" >
              <td><span>Sala {{item.sala_id}}</span></td>
            </template>

            <template  v-slot:item.fechas="{ item }" >
              <td>
                <span v-if="item.fecha_contestacion">Contestación: {{item.fecha_contestacion | formatDate}}</span>
                <br v-if="item.fecha_contestacion">
                <span>Registrada: {{item.created_at | formatDate}} {{ }}</span>
              </td>
            </template>

            <template v-slot:item.acciones="{ item }">
              <v-btn class=""  dark x-small color="green" @click="showPromocion(item)">
                <v-icon small dark left>mdi-file</v-icon>
                Ver promoción
              </v-btn>
            </template>
            <template v-slot:item.accionesExp="{ item }">
              <v-btn class=""  dark x-small color="green" @click="showExpediente(item)">
                <v-icon small dark left>mdi-file</v-icon>
                Ver Asunto
              </v-btn>
            </template>

          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination
              v-if="paginationHistorial.total > 1"
              v-model="paginationHistorial.current"
              :length="paginationHistorial.total"
              :total-visible="7"
              @input="onPageChangeHistorial"
              color="blue"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
            ></v-pagination>
          </div>
          </v-form>
           </v-card>
         </template>
       </v-dialog>
     </v-col>
   </v-row>
    <br>
  </v-card>
  </v-container>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from 'vuex'
  export default {
    data: () => ({
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      per_page_table: 1,
      per_page_table_historial: 1,
      pagination: {
        current: 1,
        total: 0
      },
      paginationHistorial: {
        current: 1,
        total: 0
      },
      alert: true,
      dialog:false,
      valid: true,
      validUser: true,
      validateJuez: true,
      validateToca:true,
      loading:false,
      leidos: '',
      turnados: '',
      tipo: '2',
      href:'',
      status:'',
      sala_id:'',
      no_toca: '',
      toca_id: '',
      numero_completo: '',
      no_expediente: '',
      countPromociones: '',
      showTabla: false,
      showAlert: false,
      isExpanded:false,
      expand:false,
      expanded: [],
      singleExpand:true,
      titleTabla: 'REGISTROS:',
      juez:'',
      promocion_id:'',
      listHistorial: [],
      listData: [],
      listTocas: [],
      active_tab:'',
      pendientesLeer:'',
      loadingTable: false,
      tipoPromocion: [
        { id:'1', nombre: 'Demandas Familiares'},
        { id:'2', nombre: 'Promociones' }
      ],
      tocaRules: [
        v => /^(\d+)(\/)(\d{4})(-[A-Z]*)*$/.test(v) || 'Ingrese formato valido',
      ],
      // listStatus: [
      //   { id: '1', nombre: 'Registrada' },
      //   { id: '2', nombre: 'Contestada' }
      // ],
    }),
    computed: {
      formTitle () {
        if (this.sala_id === 12) {
          return 'Panel de Asuntos Laborales'
        } else if (this.sala_id === 13) {
          return 'Panel de Buzón Presidencia'
        } else if (this.roleUser == 'magistrado') {
          return 'Panel de Acuerdos'
        }
        return 'Panel de Promociones'
      },
      btnTitle () {
        if (this.roleUser == 'magistrado') {
          return 'Acuerdos'
        }
        return 'Promociones'
      },
      historialTitle () {
        if (this.sala_id <= 11) {
          return 'Promociones del Toca ' + this.numero_completo
        } else if (this.sala_id === 12) {
          return 'Asunto Laboral '+ this.numero_completo
        }
      },
      listStatus(){
        if (this.roleUser == 'magistrado') {
          return [
            { id: '0', nombre: 'Pendiente de Firma' },
            { id: '1', nombre: 'Firmado' }
          ]
        } else {
          return [
            { id: '2', nombre: 'Registrada' },
            { id: '3', nombre: 'Contestada' }
          ]
        }
      },
      headers(){
        // if (this.roleUser == 'magistrado' && (this.sala_id <= 11 || this.sala_id == '')) {
        //   return [
        //     { text: 'Toca', value: 'numero_completo' },
        //     { text: 'Área', value: 'area' },
        //     { text: 'Estatus', value: 'status', sortable: false },
        //     // { text: 'Registro de fechas', value: 'fechas' },
        //     { text: 'Acciones', value: 'action', sortable: false }
        //   ]
        // }

        if (this.roleUser == 'abogado' && (this.sala_id <= 11 || this.sala_id == '')) {
          return [
            { text: 'Toca', value: 'numero_completo' },
            { text: 'Área', value: 'area' },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'action', sortable: false }
          ]
        }
        if (this.roleUser == 'abogado' && this.sala_id == 12 ){
          return [
            { text: 'Asunto', value: 'numero_completo', class: "title" },
            // { text: 'Fecha de Turno', value: 'old_fecha_turno', class: "title" },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'action', class: "title",  align: 'left', sortable: false },
            { text: '' },
          ]
        }
        if (this.sala_id == 13 ){
          return [
            { text: 'Asunto', value: 'asunto', class: "title" },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'action', class: "title",  align: 'left', sortable: false },
            { text: '' },
          ]
        }

        if (this.roleUser != 'abogado' && (this.sala_id <= 11 || this.sala_id == '')) {
          return [
            { text: 'Toca', value: 'status_secacuerdos' },
            { text: 'Área', value: 'area' },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'action', sortable: false },
          ]
        }
        if (this.roleUser != 'abogado' && this.sala_id == 12) {
          return [
            { text: 'Asunto', value: 'status_secacuerdos', class: "title" },
            { text: 'Área', value: 'area', class: "title" },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'action', class: "title",  align: 'left', sortable: false },
            { text: '' },
          ]
        }

      },
      headersHistorial() {
        if (this.sala_id <= 11 ){
          return [
            { text: 'Toca', value: 'numero_completo' },
            { text: 'Área', value: 'area' },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'acciones', sortable: false }
          ]
        }
        if (this.sala_id == 12 ){
          return [
            { text: 'Asunto', value: 'numero_completo' },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'accionesExp', sortable: false }
          ]
        }
      },
      ...mapGetters([
        "promocionesList", "roleUser", "listSalas", "listJueces", "currentUser"
      ])
    },
    watch:{
      status (val) {
        // console.log(this.status);
        this.pagination.current = 1;
        if (val && this.sala_id <= 11) {
          this.getPromociones();
        }
        if (val && this.sala_id == 12) {
          this.buscarExpediente();
        }
        if (val && this.sala_id == 13) {
          this.buscarBuzon();
        }
        if(!val && this.sala_id <= 11){
          this.getPromociones()
        }
        if(!val && this.sala_id == 12){
          this.buscarExpediente()
        }
        if(!val && this.sala_id == 13){
          this.buscarBuzon()
        }
        if (this.sala_id == '') {
          this.getPromociones()
        }
      },
      no_toca (val){
        this.pagination.current = 1;
        if(!val){
          return this.$refs.search.resetValidation()
        }
      },
      no_expediente (val){
        this.pagination.current = 1;
        if(!val){
          // return this.$refs.search.resetValidation()
        }
      },
      sala_id (val){
        this.pagination.current = 1;
        //this.expanded = []
        this.leidos = '';
        if (val <= 11) {
          this.active_tab = 'tab-1'
          //this.no_expediente = ''
          this.getPromociones();
          // this.$refs.search.reset()
        }
        if (val == 12) {
          this.active_tab = 'tab-2'
          //this.no_toca = ''
          this.buscarExpediente();
          // this.$refs.search.reset()
        }
        if (val == 13) {
          this.active_tab = 'tab-3'
          // this.$refs.search.reset()
          this.buscarBuzon();
        }
        if(!val){
          this.active_tab = 'tab-1'
          this.getPromociones();
          // return this.$refs.search.resetValidation()
        }
      },
    },
    mounted(){
      //this.validateUser()
      if (this.roleUser == 'superadmin' || this.roleUser == 'admin' || this.roleUser == 'abogado') {
        this.getPromociones()
      }
      this.getSalas()
      this.getPendientes()
      if (this.currentUser.sala_id) {
        this.sala_id = this.currentUser.sala_id
      }
      // if (this.roleUser == 'magistrado') {
      //   this.status = '0'
      //   this.titleTabla = 'REGISTROS PENDIENTES DE FIRMA'
      // }
    },
    methods: {
      clickSearch(){
        this.titleTabla = 'RESULTADO DE LA BUSQUEDA:'
        this.loadingTable = true
        if (this.sala_id == 12) {
          this.buscarExpediente()
        } else if (this.sala_id == 13) {
          this.buscarBuzon()
        } else {
          this.getPromociones()
        }
      },
      onPageChange() {
        if (this.sala_id == 12) {
          this.buscarExpediente()
        } else if (this.sala_id == 13) {
          this.buscarBuzon()
        } else {
          this.getPromociones();
        }
      },
      onPageChangeHistorial() {
        if (this.sala_id == 12) {
          this.showHistorialExp()
        } else {
          this.showToca();
        }
      },
      validateLeidos(){
        var data = this.listData
        if (this.sala_id == 12) {
          this.leidos = data.some(leido => leido.laborales_pendientes_leer > 0);
          this.turnados = data.some(turnados => turnados.status_laborales > 0);
        } else if (this.sala_id == 13) {
          this.leidos = data.some(leido => leido.buzones_pendientes_leer == 0);
          this.turnados = data.some(turnados => turnados.fecha_contestacion == null);
        } else {
          this.leidos = data.some(leido => leido.promociones_pendientes_leer > 0);
          this.turnados = data.some(turnados => turnados.status_promociones > 0);
        }
      },
      buscarBuzon() {
        this.loadingTable = true;
        this.$store.dispatch("GET_BUZONES", {
          url:"/buzones?page="+this.pagination.current,
          params: {
            // tipo:this.tipo,
            status:this.status,
            sala_id:this.sala_id,
            // no_expediente:this.no_expediente
          }
        } )
        .then((response) => {
         // console.log(response.data);
          this.loadingTable = false
          this.pagination.current = response.data.data.buzones.current_page;
          this.pagination.total = response.data.data.buzones.last_page;
          this.per_page_table = response.data.data.buzones.per_page;
          this.listData = response.data.data.buzones.data;
          if (response.data.status == 'ok') {
            this.showTabla = true
            this.showAlert = false
          } else {
            this.showAlert = true
            this.showTabla = false
          }
          this.validateLeidos()
        })
        .catch(err => {
          console.log(err);
          this.showAlert = true
          this.showTabla = false
        });
      },
      buscarExpediente() {
        this.loadingTable = true;
        this.$store.dispatch("GET_EXPEDIENTES", {
          url:"/expedientes?page="+this.pagination.current,
          params: {
            // tipo:this.tipo,
            status:this.status,
            sala_id:this.sala_id,
            no_expediente:this.no_expediente
          }
        } )
        .then((response) => {
        //  console.log(response.data);
          this.loadingTable = false
          this.pagination.current = response.data.data.expedientes.current_page;
          this.pagination.total = response.data.data.expedientes.last_page;
          this.per_page_table = response.data.data.expedientes.per_page;
          this.listData = response.data.data.expedientes.data;
          if (response.data.status == 'ok') {
            this.showTabla = true
            this.showAlert = false
          } else {
            this.showAlert = true
            this.showTabla = false
          }
          this.validateLeidos()
        })
        .catch(err => {
          console.log(err);
          this.showAlert = true
          this.showTabla = false
        });
      },
      showToca(item) {
        if (item) {
          this.toca_id = item.toca_id
          this.numero_completo = item.numero_completo
        }
        this.dialog = true
        this.$store.dispatch("GET_PROMOCIONES", {
          url:"/toca/"+this.toca_id+"/promociones?page="+this.paginationHistorial.current,
          params: {
            no_toca:this.numero_completo
          }
        } )
        .then((response) => {
          this.paginationHistorial.current = response.data.data.promociones.current_page;
          this.paginationHistorial.total = response.data.data.promociones.last_page;
          this.per_page_table_historial = response.data.data.promociones.per_page;
          this.listHistorial = response.data.data.promociones.data;
        })
        .catch(err => {
          console.log(err);
          // this.showAlert = true
          // this.showTabla = false
        });
      },
      // firmar(item){
      //   this.$store.dispatch("SHOW_PROMOCION", {
      //     url:"/promocion/"+ item.id,
      //   } )
      //   .then((response) => {
      //   this.$router.push('/firma/magistrado' )
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
      // },
      showPromocion(item){
        this.$store.dispatch("SHOW_PROMOCION", {
          url:"/promocion/"+ item.id,
        } )
        .then((response) => {
        this.$router.push('/escritos/show' )
        })
        .catch(err => {
          console.log(err);
        });
      },
      getPromociones(item) {
        this.loadingTable = true
        this.$store.dispatch("GET_PROMOCIONES", {
            url:"/promociones?page="+this.pagination.current,
            params: {
              status:this.status,
              sala_id:this.sala_id,
              no_toca:this.no_toca
            }
          })
          .then((response) => {
            //console.log(response.data);
            this.loadingTable = false
            this.pagination.current = response.data.data.promociones.current_page;
            this.pagination.total = response.data.data.promociones.last_page;
            this.per_page_table = response.data.data.promociones.per_page;
            this.listData = response.data.data.promociones.data;
            if (response.data.status == 'ok') {
              this.showTabla = true
              this.showAlert = false
            } else {
              this.showAlert = true
              this.showTabla = false
            }
            this.validateLeidos()
          })
          .catch(err => {
            console.log(err);
          });
      },
      showExpediente(item){
        // console.log(item);
        this.$store.dispatch("SHOW_EXPEDIENTE", {
          url:"/expediente/"+ item.id,
        } )
        .then((response) => {
        this.$router.push('/escritos/show' )
        })
        .catch(err => {
          console.log(err);
        });
      },
      showHistorialExp(item) {
        this.dialog = true
        this.numero_completo = item.numero_completo
        this.$store
          .dispatch("GET_ESCRITOS", {
            url:"/expediente/"+ item.id +"/escritos?page="+this.paginationHistorial.current,
            data: {
              id: item.id,
            }
          })
          .then((response) => {
            this.paginationHistorial.current = response.data.data.expedientes.current_page;
            this.paginationHistorial.total = response.data.data.expedientes.last_page;
            this.per_page_table_historial = response.data.data.expedientes.per_page;
            this.listHistorial = response.data.data.expedientes.data;
            console.log(this.listHistorial);
          })
          .catch(err => {
            console.log(err);
          });
      },
      getSalas() {
        this.$store.dispatch("GET_SALAS",  { url: "/salas" } ).then(response => {
        })
        .catch(error => {
          console.log(error);
        });
      },
      showBuzon(item){
        // console.log(item);
        this.$store.dispatch("SHOW_BUZON", {
          url:"/buzon/"+ item.id,
        } )
        .then((response) => {
        this.$router.push('/escritos/show' )
        })
        .catch(err => {
          console.log(err);
        });
      },
      getPendientes() {
        this.salaSelected = ''
        this.$store.dispatch("GET_PENDIENTES_LEER",  { url: "/abogado/pendientes-leer",
        }).then(response => {
            this.pendientesLeer = response.data.data
          // console.log(response.data);
        })
        .catch(err => {
          console.log(err);
        });
      },
      clear() {
        if (!this.no_toca && !this.no_expediente ) {
          this.$refs.search.resetValidation()
          //this.validateToca = true
        }
      },
      close() {
        this.dialog = false
        this.paginationHistorial.current = 1
      },
    }
  };
</script>
